const _temp0 = require("./level1.json");
const _temp1 = require("./level2.json");
const _temp2 = require("./level3.json");
const _temp3 = require("./level4.json");
const _temp4 = require("./level5.json");
const _temp5 = require("./level6.json");
module.exports = {
  "level1": _temp0,
  "level2": _temp1,
  "level3": _temp2,
  "level4": _temp3,
  "level5": _temp4,
  "level6": _temp5
}